import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import Cookies from "universal-cookie";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import RemoveCircleSharpIcon from "@mui/icons-material/RemoveCircleSharp";
import Styles from "../../../../../Slices/Mof/Styles.json";
import swal from 'sweetalert'
import Imagelist from "./ImageList";
import ApiSetting from "../../../../../../Settings/ApiSettings.json";
import "../../../Dashboard.css";
import axios from "axios";
const cookies = new Cookies();
const language = cookies.get("language") ? cookies.get("language") : "ar";




const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function ImagesUpload({getCurrentReportDataAfterUpdate,object,Access,advanceSearch,section_id,stage_transaction_type_id}) {
    const [accessHere,setAccessHere]=useState(Access)
    const [countImageList,setCountImageList]=useState(0);
    const [countImage, setCountImage] = useState([]);
    const [Resources,setResources]=useState([])
    const [loading3,setLoading3]=useState(false)
    const [snackBar, setsnackBar] = useState({
        open: false,
        vertical: "bottom",
        horizontal: "center",
        message: "",
        severity: "",
    });
    const  [filesObject,setFilesObject]=useState({
      index: 0,
      fileType: null,
      ImageForWhat: null,
      file: null,
      mem: null,
      imgURl: null,
      pdfCheck: 0,
    });
    const [addAccess,setAddAccess]=useState()

    const pushImageFiles =async (resource) => {
      if(resource?.file==null){
        swal("تحذير!", 'يجب اختيار ملف او صورة', "success");
        return;
      }
       let data=null;
       let formData=new FormData();
       formData.append('income_report_tax_id',object?.id)
       formData.append('file_type',resource?.fileType)
       formData.append('image_for_what', resource?.ImageForWhat)
       formData.append('file',resource?.file)
       formData.append('section_id',section_id)
       formData.append('stage_transaction_type_id',stage_transaction_type_id)
       formData.append('user_id',cookies.get('user_id'))
       formData.append('role_id',cookies.get('role_id')+1)


       try{
        data=await axios({
          method:'post',
          url:ApiSetting.apiUrl+'/income_tax_report/image_for_income_tax_report',
          data:{
            income_report_tax_id:object?.id,
            file_type:resource?.fileType,
            image_for_what:resource?.ImageForWhat,
            file:resource?.file,
          },
          headers:{
            "Content-Type": "multipart/form-data",
            'Accept':'application/json',
            "X-localization": language,
          }
        })
        if(data){
          if(data?.data?.status==200){
           swal("نجحت العملية!", `${data?.data?.message}`, "success");
            advanceSearch()
            setFilesObject({  
              index: 0,
              fileType: null,
              ImageForWhat: null,
              file: null,
              mem: null,
              imgURl: null,
              pdfCheck: 0,
            })
            setResources([...Resources,data?.data?.data])
            getCurrentReportDataAfterUpdate()

            // document.getElementById('Images').value=null;
          }else{
           swal(" فشلت العملية!", `${data?.data?.message}`, "warning");
           setFilesObject({  
            index: 0,
            fileType: null,
            ImageForWhat: null,
            file: null,
            mem: null,
            imgURl: null,
            pdfCheck: 0,
          })
          // document.getElementById('Images2').value=null;

          }
        }
       }catch(err){
        //  console.log(err.message);
         swal(" فشلت العملية!", `${err?.message}`, "error");

       }
    }

   useEffect(() => {
      if(object?.resources_for_income_tax_reports?.length>0){
         let arr=[];
         object?.resources_for_income_tax_reports?.map((data)=>{
           arr.push({
             ...data,
             new:false,
           })
         })
         setResources(arr);
      }
   }, [object]);

   const checkAccessPrivilegesCanEdit=()=>{
    let check=false;
    // console.log('AccesDDDDDDDDDDDDDDDD')

    if(Access?.length>0){
      // console.log('AccesDDDDDDDDDDDDDDDD',Access)

    Access?.map((data)=>{
      // console.log('AccesDDDDDDDDDDDDDDDD')

       if(data==2){
        //  check=true;
        setAddAccess(true)
       }
    })
  }
    // return check;
  }


    useEffect(()=>{
        // console.log("access",Access);
        if(Access?.length>0){
          setAccessHere(Access)
          checkAccessPrivilegesCanEdit();
        }
    },[Access])

    useEffect(()=>{
      if(filesObject?.file){
        pushImageFiles(filesObject)
      }
    },[filesObject])


    


    return (
        <div className="Dashboard_MOF1">
            {/*###==>images upload ...  */}
            <h4
                style={{
                    marginRight: "10px",
                    color: "#5f7b8a",
                }}
            >
                المستمسكات{" "}
            </h4>
            <Imagelist object={object}  Access={accessHere} Resources={Resources} setResources={setResources} section_id={section_id} stage_transaction_type_id={stage_transaction_type_id}/>
            {addAccess?
              <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexFlow: "row wrap",
                    width: "98%",
                    minWidth: 200,
                    border: "1px solid",
                    borderColor: "#5f7b8a",
                    borderRadius: 10,
                    margin: 10,
                  //   marginBottom:60,
                    paddingBottom: 10,
                  }}
                >
                  {/* <div
                    style={{
                      display: "flex",
                      width: "100%",
                      minWidth: 200,
                      marginTop: 10,
                      paddingLeft: 10,
                      paddingTop: 10,
                      paddingRight: 10,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FormControl fullWidth>
                      <AddCircleSharpIcon
                        className="hoverPluse"
                        onClick={() => {
                          if(countImageList==0)
                            setCountImageList(1)
                        }}
                        style={{
                          fontSize: 40,
                          color: Styles.Colors.MOF_Modal_BGcolor,
                          cursor: "pointer",
                        }}
                      />
                    </FormControl>

                    <Typography className="fontForError"></Typography>
                  </div> */}

                  
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            flexFlow: "row wrap",
                            width: "100%",
                            minWidth: 200,
                            // border: "1px solid",
                            borderColor: "#5f7b8a",
                            borderRadius: 10,
                            margin: 10,
                            paddingBottom: 10,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              // width: "20%",
                              flex: 1,
                              minWidth: 150,
                              marginTop: 10,
                              paddingLeft: 10,
                              paddingTop: 10,
                              paddingRight: 10,
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <FormControl fullWidth>
                              <InputLabel id="career-simple-select-label">
                                نوع الملف
                              </InputLabel>
                              <Select
                                labelId="career-simple-select-label"
                                id="career-simple-select"
                                value={filesObject.fileType?filesObject.fileType:null}
                                label="نوع الملف "
                                onChange={(e) => {
                                  // setFileType(e.target.value);
                                  
                                  if (e.target.value == "image") {
                                    console.log(e.target.value);
                                      setFilesObject({
                                        ...filesObject,
                                        index:countImage.length+1,
                                        fileType :e.target.value,
                                        mem: "image/png,image/jpg,image/jpeg",
                                      })

                                  } else if (e.target.value == "pdf") {
                                    setFilesObject({
                                      ...filesObject,
                                      index:countImage.length+1,
                                      fileType:e.target.value,
                                      mem: "application/pdf",
                                    })
                                  
                                  }
                                }}
                              >
                                <MenuItem value={"image"}>{"صورة"}</MenuItem>
                                <MenuItem value={"pdf"}>{"ملف pdf"}</MenuItem>
                              </Select>
                            </FormControl>

                            <Typography className="fontForError"></Typography>
                          </div>
                          {filesObject.fileType == "image" ? (
                          <div
                            style={{
                              display: "flex",
                              // width: "20%",
                              flex: 1,
                              minWidth: 150,
                              marginTop: 10,
                              paddingLeft: 10,
                              paddingTop: 10,
                              paddingRight: 10,
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <FormControl fullWidth>
                              <InputLabel id="career-simple-select-label">
                                يرجا اختيار اسم الصورة
                              </InputLabel>
                              <Select
                                labelId="career-simple-select-label"
                                id="career-simple-select"
                                value={filesObject.ImageForWhat?filesObject.ImageForWhat:null}
                                label="يرجا اختيار اسم الصورة"
                                onChange={(e) => {
                                  setFilesObject({
                                    ...filesObject,
                                    index:countImage.length+1,
                                    ImageForWhat: e.target.value,
                                    })
                                
                                }}
                              >
                                <MenuItem value={"بطاقة الاحوال المدنية"}>
                                  {"بطاقة الاحوال المدنية"}
                                </MenuItem>
                                <MenuItem value={"بطاقة السكن"}>
                                  {"بطاقة سكن "}
                                </MenuItem>
                              </Select>
                            </FormControl>

                            <Typography className="fontForError"></Typography>
                          </div>
                          ) : null}
                          <div
                            style={{
                              display: "flex",
                              // width: "20%",
                              flex: 1,
                              minWidth: 150,
                              marginTop: 10,
                              paddingTop: 10,
                              paddingLeft: 10,
                              paddingRight: 10,
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <FormControl fullWidth>
                              <span
                                // href="#"
                                onClick={() => {
                                  if (filesObject.fileType) {
                                    if (filesObject.fileType == "image") {
                                      if (filesObject.ImageForWhat) {
                                        document
                                          .querySelector(".images2")
                                          .click();
                                      } else {
                                        setsnackBar({
                                          ...snackBar,
                                          open: true,
                                          severity: "warning",
                                          message:
                                            "يجب اختيار اسم الصورة لرفع الملف",
                                        });
                                      }
                                    } else {
                                      document
                                        .querySelector(".images2")
                                        .click();
                                    }
                                  } else {
                                    setsnackBar({
                                      ...snackBar,
                                      open: true,
                                      severity: "warning",
                                      message: "يجب اختيار نوع الصورة لرفع الملف",
                                    });
                                  }
                                }}
                              >
                                <button class="boton">ارفع مستند</button>
                              </span>
                              <input
                                type="file"
                                id="Images2"
                                className="images2 d-none"
                                name="images2"
                                accept={filesObject.mem?filesObject.mem:null}
                                onChange={(e) => {
                                  // console.log(e.target.files[0]);
                                  // e.target.click();
                                  if(filesObject.fileType=='image'){
                                    // console.log('d2');
                                    setFilesObject({
                                      ...filesObject,
                                      index:countImage.length+1,
                                      file: e.target.files[0],
                                      mem: "image/png,image/jpg,image/jpeg",
                                      imgURl: window.URL.createObjectURL(e.target.files[0]),
                                      pdfCheck: 0,
                                    })
                                    //  pushImageFiles({
                                    //   ...filesObject,
                                    //   // index:countImage.length+1,
                                    //   file: e.target.files[0],
                                    //   // mem: "image/png,image/jpg,image/jpeg",
                                    //   // imgURl: window.URL.createObjectURL(e.target.files[0]),
                                    //   // pdfCheck: 0,
                                    //  },e.target.files[0])
                                  }else if(filesObject.fileType=='pdf'){
                                    console.log('d1');
                                    setFilesObject({
                                      ...filesObject,
                                      index:countImage.length+1,
                                      file: e.target.files[0],
                                      mem: "application/pdf",
                                      imgURl:"https://play-lh.googleusercontent.com/BkRfMfIRPR9hUnmIYGDgHHKjow-g18-ouP6B2ko__VnyUHSi1spcc78UtZ4sVUtBH4g",
                                      pdfCheck: 1,
                                    })
                                    //  pushImageFiles({
                                    //   ...filesObject,
                                    //   index:countImage.length+1,
                                    //   file: e.target.files[0],
                                    //   mem: "application/pdf",
                                    //   imgURl:"https://play-lh.googleusercontent.com/BkRfMfIRPR9hUnmIYGDgHHKjow-g18-ouP6B2ko__VnyUHSi1spcc78UtZ4sVUtBH4g",
                                    //   pdfCheck: 1,
                                    //  },e.target.files[0])
                                  }

                                }}
                              />
                            </FormControl>
                            <Typography className="fontForError"></Typography>
                          </div>

                          {/* <div
                            style={{
                              display: "flex",
                              // width: "20%",
                              flex: 1,
                              minWidth: 200,
                              marginTop: 10,
                              paddingLeft: 10,
                              paddingTop: 10,
                              paddingRight: 10,
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <FormControl fullWidth>
                            <Button
                              variant="contained"
                              style={{
                              backgroundColor: "#5f7b8a",
                              width: "40%",
                                fontSize: "20px",
                              }}
                              onClick={() => {
                              //  sentDateOfForm();
                              pushImageFiles();
                                
                              }}
                  >
                      {!loading3 ? (
                      "أضافة"
                    ) : (
                      <div class="spinner-border " role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    )}
                  </Button>
                            </FormControl>

                            <Typography className="fontForError"></Typography>
                          </div> */}
                        </div>
                      
                    
              </div>
            : null}
            <br/>
            <br/>
            <br/>
            <br/>


            {/* snack alert box here ... */}
            <Snackbar
              open={snackBar.open}
              autoHideDuration={6000}
              onClose={() => {
                setsnackBar({ ...snackBar, open: false });
              }}
              anchorOrigin={{
                vertical: snackBar.vertical,
                horizontal: snackBar.horizontal,
              }}
            >
              <Alert
                onClose={() => {
                  setsnackBar({ ...snackBar, open: false });
                }}
                severity={snackBar.severity}
                sx={{ width: "100%" }}
              >
                {snackBar.message}
              </Alert>
            </Snackbar>
        </div>
    )
}

export default ImagesUpload